// src/consent-init.ts
// This file sets up default consent BEFORE any scripts load
const COOKIE_CONSENT_KEY = 'sudoku_vs_cookie_consent';

declare global {
  interface Window {
    gtag: (command: string, action: string, params?: any) => void;
    gaTrackingReady?: boolean;
    dataLayer: any[];
  }
}

// Initialize dataLayer
window.dataLayer = window.dataLayer || [];

// Define gtag function
function gtag(...args: any[]) {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

window.gtag = gtag;

// Check for stored consent preferences
const storedConsent = localStorage.getItem(COOKIE_CONSENT_KEY);

if (storedConsent) {
  try {
    const parsedConsent = JSON.parse(storedConsent);

    // Apply stored consent settings immediately
    gtag('consent', 'update', {
      'ad_storage': parsedConsent.ad_storage || 'granted',
      'analytics_storage': parsedConsent.analytics_storage || 'granted',
      'ad_user_data': parsedConsent.ad_user_data || 'granted',
      'ad_personalization': parsedConsent.ad_personalization || 'granted'
    });
  } catch (error) {
    applyDefaultConsent();
  }
} else {
  // No stored preferences, apply default
  applyDefaultConsent();
}

function applyDefaultConsent() {
  // Set default consent state to granted
  gtag('consent', 'default', {
    'ad_storage': 'granted',
    'analytics_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted'
  });
}

// Set consent mode version
gtag('set', 'consent_mode_version', 2);

export const consentInitialized = true;